// columnConfig.js

import ColumnType from "./ColumnType";

const columnConfig = Object.freeze({
  [ColumnType.ORDER_TYPE]: {
    labelId: "incomingOrders.columns.type",
    label: "Typ",
  },
  [ColumnType.SUPPLIER_ORDER_NO]: {
    labelId: "incomingOrders.columns.ourOrderNumber",
    label: "Vårt ordernr", 
    sortField: "SupplierOrderNo",
    required: false,
  },
  [ColumnType.SUPPLIER_ORDER_REFERENCE]: {
    labelId: "incomingOrders.columns.supplierOrderReference",
    label: "KL Orderreferens", //Ska vara företagstext i framtiden!
    sortField: "SupplierOrderReference",
    required: true,
  },
  //[ColumnType.ORDER_ID]: {
  //  label: "Ert ordernr",
  //  sortField: "OrderId",
  //},
  [ColumnType.ORDER_REFERENCE]: {
    labelId: "incomingOrders.columns.orderReference",
    label: "Referens",
    sortField: "OrderReference",
  },
  [ColumnType.RECEIVER]: {
    labelId: "incomingOrders.columns.receiver",
    label: "Kund / Mottagare",
    sortField: "DeliveryAddress1",
  },
  [ColumnType.ORDER_DATE]: {
    labelId: "incomingOrders.columns.orderDate",
    label: "Orderdatum",
    sortField: "OrderDate",
  },
  [ColumnType.SUMMARY]: {
    labelId: "incomingOrders.columns.content",
    label: "Innehåll",
  },
  [ColumnType.DELIVERY_ADDRESS_2]: {
    labelId: "incomingOrders.columns.deliveryAddress2",
    label: "Leveransadress",
    sortField: "DeliveryAddress2",
  },
  [ColumnType.DELIVERY_DATE]: {
    labelId: "incomingOrders.columns.requestedDeliveryDate",
    label: "Önskat leveransdatum",
    sortField: "DeliveryDateWish",
  },
  [ColumnType.ORDER_STATUS]: {
    labelId: "incomingOrders.columns.status",
    label: "Status",
    sortField: "OrderStatus",
  },
  [ColumnType.SOURCE]: {
    labelId: "incomingOrders.columns.source",
    label: "Källa",
  },
  [ColumnType.ROW_COUNT]: {
    labelId: "incomingOrders.columns.rows",
    label: "Rader",
    align: "right",
  },
});

export default columnConfig;
